import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormValidationModule } from '../form-validation/form-validation.module';
import { ContextBarComponent } from './context-bar.component';
import { ContextBarService } from './context-bar.service';
import { PortalModule } from '@angular/cdk/portal';
import { ContextBarDynamicPlaceholderComponent } from './dynamic-placeholder/context-bar-dynamic-placeholder.component';
import { ElementsModule } from '@shared/elements/elements.module';
import { IconComponentModule } from '@shared/elements/icon/icon-component.module';
import { CoreModule } from '@core/core.module';

@NgModule({
    imports: [
        IconComponentModule,
        ElementsModule,
        CommonModule,
        CoreModule.forChild(),
        FormValidationModule,
        PortalModule,
    ],
    exports: [ContextBarComponent],
    declarations: [ContextBarComponent, ContextBarDynamicPlaceholderComponent],
    providers: [ContextBarService],
})
export class ContextBarModule {}
